<div class="transport-issues-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      {{'transport issues' | translate: ['tmc.transport-issues-dialog.title', translationService.language]}}
    </h2>

    <i class="horizontal-divider"></i>

    <div class="top-info">
      <app-transport-info-panel [carrier]="transport.carrier" [identifier]="transport.identifier"
        [driver]="transport.driver" [scope]="transport.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <form #editForm="ngForm">
        <div class="issue-box" *ngFor="let issue of getNonDeletedIssues()">

          <mat-form-field style="grid-column: 1; grid-row: 1;">
            <mat-label>
              {{'type' | translate: ['tmc.transport-issues-dialog.label.type', translationService.language]}}
            </mat-label>
            <mat-select [required]="true" name="{{'type_' + issue.id}}" [(ngModel)]="issue.issueTypeId"
              (selectionChange)="onTypeSelectionChange($event, issue)">
              <mat-option *ngFor="let o of transport.issueTypes" [value]="o.id">
                {{o.id | translate: [o.nameDictionaryKey, translationService.language]}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="grid-column: 2; grid-row: 1;">
            <input name="{{'delay_' + issue.id}}" matInput [(ngModel)]="issue.delay" #ctrlDelay="ngModel" type="number"
              [appMin]="+cps.getClientParamValue('ui-component.transport-issues-dialog.delay.min', true)"
              [appMax]="+cps.getClientParamValue('ui-component.transport-issues-dialog.delay.max', true)"
              [required]="cps.isRequired('ui-component.transport-issues-dialog.delay.min', true)"
              placeholder="{{'delay' | translate: ['tmc.transport-issues-dialog.label.delay', translationService.language]}}"
              [readonly]="false" required appPositiveInteger min="0" (keydown.enter)="preventEnterKeydown()">
            <mat-error *ngIf="showValuePositiveIntegerError(ctrlDelay)">
              {{'delay must be a positive and Integer' | translate:
              ['tmc.transport-issues-dialog.error.delay-no-integer', translationService.language]}}
            </mat-error>
          </mat-form-field>

          <mat-form-field style="grid-column: 1 / span 2; grid-row: 2;">
            <textarea name="{{'text_'+issue.id}}"
              placeholder="{{'text' | translate: ['tmc.transport-issues-dialog.label.text', translationService.language]}}"
              matInput [(ngModel)]="issue.text"
              [required]="cps.isRequired('ui-component.transport-issues-dialog.text.min-length', true)"
              [minLength]="cps.getClientParamValue('ui-component.transport-issues-dialog.text.min-length', 0)"
              [maxlength]="9999" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5">
            </textarea>
          </mat-form-field>

          <div class="centered" style="grid-column: 3; grid-row: 1 / span 2;">
            <button class="remove-button" mat-icon-button (click)="removeIssue(issue)"
              [disabled]="isRemoveIssueDisabled(issue)"
              [matTooltip]="'remove issue' | translate:['tmc.transport-issues-dialog.action.removeIssue', translationService.language]">
              <sc-icon iconClass="fa-minus"></sc-icon>
            </button>
          </div>
        </div>
      </form>

      <div class="add-button-wrapper">
        <button class="add-issue-button" mat-stroked-button (click)="addIssue()" [disabled]="isAddIssueDisabled()"
          [matTooltip]="'add issue' | translate:['tmc.transport-issues-dialog.action.addIssue', translationService.language]">
          <sc-icon iconClass="fa-plus"></sc-icon>
        </button>
      </div>

    </div>

    <div>
      <i class="horizontal-divider"></i>
      <div class="messages">
        <app-service-response [responseMessages]="responseMessages"></app-service-response>
      </div>

      <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button class="cancel-button" (click)="cancel()">{{'cancel' | translate:
          ['tmc.transport.routing.action.cancel', translationService.language]}}</button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="save()" class="confirm-button" [disabled]="isSaveDisabled()">{{'save' |
          translate: ['tmc.transport.routing.action.save', translationService.language]}}</button>
      </sc-actionbar>

    </div>

  </div>